/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import classNames from 'classnames';
import React from 'react';

import Context from './Context';

function Caption({
	children,
	className,
	...otherProps
}: React.HTMLAttributes<HTMLDivElement | HTMLSpanElement>) {
	const {interactive} = React.useContext(Context);
	const TagName = interactive ? 'span' : 'div';

	return (
		<TagName
			className={classNames(className, 'card-detail')}
			{...otherProps}
		>
			{children}
		</TagName>
	);
}

export default Caption;
